export enum FormValidationRuleEnum {
  minValue = 'minValue',
  maxValue = 'maxValue',
  minLength = 'minLength',
  maxLength = 'maxLength',
  isTimestamp = 'isTimestamp',
  isOfferStatusEnum = 'isOfferStatusEnum',
  isRequired = 'isRequired',
}
